// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2ixod","label":"SetPasswdForm_label__1cds8"};